import React from "react";

const Phrases = ({ items }) => {
    if (items.length === 0) {
        return ;
    }
    return (
        <div className='mt-3'>
            {items && items.length > 0  && (
                <span className='text-[#7A7A7A] font-medium !text-[clamp(12px,1.1vw,16px)]'>Say something like...</span>
            )}
        <div className="flex flex-wrap gap-2 pt-3">
            {items && items.map((text, index) => (
                <span
                    key={index}
                    className="text-[#6F6F6F] text-[clamp(10px,0.92vw,13px)] px-3 py-1.5 md:px-5 md:py-2 rounded-full bg-[#F4F4F4] border border-[#E8E8E8]"
                >
                    {text}
                </span>
            ))}
        </div>
        </div>
    );
};

export default Phrases;
